/**
 * Created by masoud on 06/05/17.
 */
import React from "react";
import createClass from "create-react-class";
import PropTypes from "prop-types";
import { isAndroid, isIOS } from "react-device-detect";

import DownloadSms from "./DownloadSms.react";

import DefaultDownloadLinks from "../../../config/DownloadLinks";
require("../../../../less/DownloadLinks.less");

const DownloadLinks = createClass({
  getInitialState() {
    return {
      Message: null,
      isCaptcha: false
    };
  },
  getDefaultProps() {
    return { links: DefaultDownloadLinks };
  },
  render() {
    if (isAndroid) {
      return (
        <div className="Download-Links">
          <div className="Apps dl-btn-responsive">
            <a
              href={
                this.props.links.play_link || DefaultDownloadLinks.play_link
              }
              target="_blank"
            >
              <img
                src="/assets/images/download-badges/google-play-badge.png"
                title="دانلود از گوگل‌پلی"
                alt="دانلود از گوگل‌پلی"
              />
            </a>
            <a
              href={
                this.props.links.bazaar_link || DefaultDownloadLinks.bazaar_link
              }
              target="_blank"
            >
              <img
                src="/assets/images/download-badges/bazaar.png"
                title="دانلود از بازار"
                alt="دانلود از بازار"
              />
            </a>
          </div>

          <h6>یا</h6>

          <DownloadSms />

          <div className="Apps dl-btn-responsive">
            <p>همچنین قابل دسترس از طریق</p>
            <a
              href={
                this.props.links.web_app_link ||
                DefaultDownloadLinks.web_app_link
              }
              target={"_blank"}
            >
              <img
                src="/assets/images/download-badges/snapp_pwa.png"
                title="نسخه تحت وب اسنپ"
                alt="نسخه تحت وب اسنپ"
              />
            </a>
          </div>
        </div>
      );
    }

    if (isIOS) {
      return (
        <div className="Download-Links">
          <div className="Apps dl-btn-responsive">
            <div className="download-link-title">
              دسترسی به وب اپلیکیشن نسخه ماندگار اسنپ
            </div>
            <a
              href={
                this.props.links.web_app_link ||
                DefaultDownloadLinks.web_app_link
              }
              target="_blank"
            >
              <img
                src="/assets/images/download-badges/snapp_pwa.png"
                title="نسخه تحت وب اسنپ"
                alt="نسخه تحت وب اسنپ"
              />
            </a>
            <a
              href={
                this.props.links.sibapp_link || DefaultDownloadLinks.sibapp_link
              }
              target="_blank"
            >
              <img
                src="/assets/images/download-badges/sibapp-badge-white.png"
                title="دانلود نسخه iOS از سیب اپ"
                alt="دانلود نسخه iOS از سیب اپ"
              />
            </a>
            <a
              href={
                this.props.links.iApp_link || DefaultDownloadLinks.iApp_link
              }
              target="_blank"
            >
              <img
                src="/assets/images/download-badges/iApps.png"
                title="نسخه تحت آی‌اپس اسنپ"
                alt="نسخه آی‌اپس اسنپ"
              />
            </a>
            <a
              href={
                this.props.links.sibche_link || DefaultDownloadLinks.sibche_link
              }
              target="_blank"
            >
              <img
                src="/assets/images/download-badges/sibche.png"
                title="دانلود نسخه iOS از سیبچه"
                alt="دانلود نسخه iOS از سیبچه"
              />
            </a>
          </div>

          {/* <div className="IOS-Help">
                    <p>چطوری اسنپ را روی گوشی خود نصب کنید</p>
                    <p>۱. اپلیکیشن را دانلود کنید.</p>
                    <p>۲. انجام تنظیمات روی گوشی. <a href={this.props.links.store_link || DefaultDownloadLinks.store_link} target="_blank">بیشتر بدانیم</a></p>
                </div> */}

          <h6>یا </h6>
          <DownloadSms />
        </div>
      );
    }

    return (
      <div className="Download-Links">
        <DownloadSms />
        <h6>یا</h6>

        <div className="Apps">
          <div className="androidLinks dl-links-wrapper">
            <a
              href={
                this.props.links.play_link || DefaultDownloadLinks.play_link
              }
              target="_blank"
            >
              <img
                src="/assets/images/download-badges/google-play-badge.png"
                title="دانلود از گوگل‌پلی"
                alt="دانلود از گوگل‌پلی"
              />
            </a>
            <a
              href={
                this.props.links.bazaar_link || DefaultDownloadLinks.bazaar_link
              }
              target="_blank"
            >
              <img
                src="/assets/images/download-badges/bazaar.png"
                title="دانلود از بازار"
                alt="دانلود از بازار"
              />
            </a>
          </div>
          <div className="iosLinks dl-links-wrapper">
            <a
              href={
                this.props.links.web_app_link ||
                DefaultDownloadLinks.web_app_link
              }
              target="_blank"
            >
              <img
                src="/assets/images/download-badges/snapp_pwa.png"
                title="نسخه تحت وب اسنپ"
                alt="نسخه تحت وب اسنپ"
              />
            </a>
            <a
              href={
                this.props.links.sibapp_link || DefaultDownloadLinks.sibapp_link
              }
              target="_blank"
            >
              <img
                src="/assets/images/download-badges/sibapp-badge-white.png"
                title="دانلود نسخه iOS از سیب اپ"
                alt="دانلود نسخه iOS از سیب اپ"
              />
            </a>
          </div>
          <div className="iosLinks dl-links-wrapper">
            <a
              href={
                this.props.links.iApp_link || DefaultDownloadLinks.iApp_link
              }
              target="_blank"
            >
              <img
                src="/assets/images/download-badges/iApps.png"
                title="نسخه تحت آی‌اپس اسنپ"
                alt="نسخه آی‌اپس اسنپ"
              />
            </a>
            <a
              href={
                this.props.links.sibche_link || DefaultDownloadLinks.sibche_link
              }
              target="_blank"
            >
              <img
                src="/assets/images/download-badges/sibche.png"
                title="دانلود نسخه iOS از سیبچه"
                alt="دانلود نسخه iOS از سیبچه"
              />
            </a>
          </div>
        </div>
      </div>
    );
  }
});

DownloadLinks.propTypes = {
  links: PropTypes.any
};

module.exports = DownloadLinks;



// WEBPACK FOOTER //
// ./src/js/components/Pages/DownloadPage/DownloadLinks.react.js